import { render, staticRenderFns } from "./EnderecoForm.vue?vue&type=template&id=1b0e55bc&"
import script from "./EnderecoForm.js?vue&type=script&lang=js&"
export * from "./EnderecoForm.js?vue&type=script&lang=js&"
import style0 from "./EnderecoForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QInput from 'quasar/src/components/input/QInput.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QColor from 'quasar/src/components/color/QColor.js';
import qInstall from "../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QInput,QSelect,QIcon,QColor});
